import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getBalance} from "../../redux/actions/navbar";
import Loading from "../../components/Loading";
import {getVendorType} from "../../services/auth";
import LabBottomNavigation from "../../components/LabBottomNavigation";

const Profile = (props) => {
    const {get_balance_waiting,get_balance_success} = useSelector(state => state.navbar);
    const [balance,setBalance] = useState(0);
    const dispatch = useDispatch();
    const vendor_type = getVendorType();

    const LogOut = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.reload();
    }
    useEffect(() => {
        dispatch(getBalance());
    },[dispatch]);
    useEffect(() => {
        if (get_balance_success.result && get_balance_success.result === 'SUCCESS'){
            setBalance(get_balance_success.data.balance);
        }
    },[get_balance_success]);
    const getPrettyBalance = (balance) => {
        return balance.toString().replace(new RegExp(',', 'g'), '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    }
    return (
        <>
            {
                vendor_type !== 'DRUG' ? <LabBottomNavigation {...props} /> : null
            }
            <div className="profile-lab-holder">
                {
                    get_balance_waiting ? <Loading /> :
                        <div className="balance-holder-profile shadow-sm">
                            <div className="balance-title-profile">
                                مانده حساب شما
                                <span className="unit">(تومان)</span>
                            </div>
                            <div className="balance-value-profile">
                                {getPrettyBalance(balance)}
                            </div>
                        </div>
                }
                <button className="btn btn-small btn-success exit-btn" onClick={() => LogOut()}>خروج از حساب کاربری</button>
            </div>
        </>
    )
};

export default Profile;